import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getListRows, getTotalPages } from '@/shared/lib/pagination';
import { Pagination } from '@/shared/ui/Pagination';
import { QueryStatus } from '@/shared/ui/QueryStatus';
import { fetchCallsMap } from './api';

interface CallRow extends Record<string, unknown> {
  id: number | string;
  click_time?: string;
  auto?: string;
  service?: string;
  norm_hours?: string;
  cost?: string;
  service_station?: string;
}

export const CallsMapPage = () => {
  const [page, setPage] = useState(1);

  const { data, isLoading, error } = useQuery({
    queryKey: ['calls-map', page],
    queryFn: () => fetchCallsMap(page),
  });

  const rows = getListRows<CallRow>(data, ['data']);

  return (
    <>
      <section className="content-header">
        <h1>Звонки с карты</h1>
      </section>
      <section className="content">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title">Список звонков</h3>
          </div>
          <div className="box-body">
            <QueryStatus isLoading={isLoading} error={error} errorText="Ошибка загрузки звонков" />
            <div style={{ overflowX: 'auto' }}>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>id</th>
                    <th>Время клика</th>
                    <th>Автомобиль</th>
                    <th>Услуга</th>
                    <th>Нормочасы</th>
                    <th>Стоимость</th>
                    <th>СТО</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>{row.click_time}</td>
                      <td>{row.auto}</td>
                      <td>{row.service}</td>
                      <td>{row.norm_hours}</td>
                      <td>{row.cost}</td>
                      <td>{row.service_station}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Pagination page={page} totalPages={getTotalPages(data)} onChange={setPage} />
          </div>
        </div>
      </section>
    </>
  );
};
